var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRawCv1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 166,
    viewBox: "0 0 200 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8934",
    "data-name": "Group 8934",
    transform: "translate(-1034.382 -367.155)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1513",
    "data-name": "Rectangle 1513",
    width: 200,
    height: 166,
    transform: "translate(1034.382 367.155)",
    fill: "#2d4294"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8932",
    "data-name": "Group 8932",
    transform: "translate(-6.933 -6.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8926",
    "data-name": "Group 8926",
    transform: "translate(1094.912 410.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7708",
    "data-name": "Path 7708",
    d: "M55.966,56.522l.047,92.237h92.759V56Zm91.964,91.264-91.021.155-.023-90.378,91.021-.155Z",
    transform: "translate(-55.966 -56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7709",
    "data-name": "Path 7709",
    d: "M182.678,134.255s-.4.434-32.579,32.614c-.2.2-3.122,11.021-3.122,11.021s10.788-2.949,10.992-3.151c31.833-31.831,32.8-32.8,32.8-32.8l-8.095-7.688Zm-25.27,39.815-9.339,2.723,2.692-9.334,31.918-32.351,7.2,6.835Zm-36.052-53.083,31.252.331,28.113-.331V120H121.355Zm0,11.086H173.3v-.942H121.355Zm0,11.113h40.814v-.924H121.355Zm0,11.262h29.683v-1.055H121.355Zm22.262,10.076H121.355v.786h22.262Zm-3.71,11.131H121.355v.941h18.552Z",
    transform: "translate(-104.612 -105.159)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8931",
    "data-name": "Group 8931",
    transform: "translate(1160.677 474.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7714",
    "data-name": "Path 7714",
    d: "M16.669,28.728,24.5,20.851l-.461-.485-7.6,7.587-3.684-3.69-.461.506,3.915,3.959Z",
    transform: "translate(-8.283 -13.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7715",
    "data-name": "Path 7715",
    d: "M10.439,20.878h0a10.439,10.439,0,0,0,7.381-17.82A10.37,10.37,0,0,0,10.44,0h0A10.439,10.439,0,0,0,3.058,17.82,10.37,10.37,0,0,0,10.439,20.878ZM3.52,3.519A9.722,9.722,0,0,1,10.44.652h0A9.787,9.787,0,0,1,17.36,17.359a9.721,9.721,0,0,1-6.92,2.866h0A9.786,9.786,0,0,1,3.52,3.519Z",
    transform: "translate(-0.001)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawCv1);
export default __webpack_public_path__ + "static/media/raw-cv-1.d76d85b095269d16e9de701eaef35d34.svg";
export { ForwardRef as ReactComponent };